import {Component, OnInit} from '@angular/core';
import {LoanApplicationService} from './loan-application.service';
import {ActivatedRoute} from '@angular/router';
import {Observable} from 'rxjs';

@Component({
  selector: 'bb-loan-application',
  templateUrl: './loan-application.component.html',
  styleUrls: ['./loan-application.component.scss'],
})
export class LoanApplicationComponent {
  constructor(public loan: LoanApplicationService,
              private route: ActivatedRoute) {
    this.loan.routePrefix.next(this.route.routeConfig.path);
  }

  isPage(index: number): Observable<boolean> {
    return this.loan.pageIndex.map(p => p === index);
  }
}
